angular.module 'zc.master'

.directive 'masterMenu', ($state, Devise) ->
  directive =
    restrict: "EA"
    scope: {}
    replace: true
    templateUrl: '/templates/master/views/directives/master_menu.html'
    link: (scope, elem, attrs) ->
      scope.Devise = Devise

      scope.signOut = Devise.signOut

  directive



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/directives/master_menu_directive.js.coffee